import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  makeStyles,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from '@material-ui/core';
import React from 'react';
import { Link as RRLink, LinkProps as RRLinkProps } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },
  // Kit inputs use a static label above the control (Input spec), not a
  // floating label: 14px / 500 / --fg-heading with a 6px gap.
  fieldLabel: {
    fontSize: 'var(--text-label)',
    lineHeight: 'var(--text-label--line-height)',
    fontWeight: 500,
    color: 'var(--fg-heading)',
    marginBottom: 6,
  },
  button: {
    marginTop: 20,
  },
  // Kit link variant: text-primary, underline on hover with 4px offset
  link: {
    marginTop: 20,
    fontSize: 'var(--text-label)',
    lineHeight: 'var(--text-label--line-height)',
    fontWeight: 500,
    color: 'var(--fg-heading)',
    textDecoration: 'none',
    textUnderlineOffset: '4px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  form: {
    minWidth: '100%',
  },
}));

export const TextField = React.forwardRef<HTMLDivElement, MuiTextFieldProps>(
  function TextField({ label, ...props }, ref) {
    const classes = useStyles();
    return (
      <div ref={ref} className={classes.field}>
        {label && <span className={classes.fieldLabel}>{label}</span>}
        <MuiTextField {...(props as MuiTextFieldProps)} variant="outlined" fullWidth />
      </div>
    );
  },
);

export const Button = (props: MuiButtonProps) => {
  const classes = useStyles();
  return (
    <MuiButton
      color="primary"
      variant="contained"
      type="submit"
      className={classes.button}
      fullWidth
      {...props}
    />
  );
};

export const Link = (props: RRLinkProps) => {
  const classes = useStyles();
  return <RRLink {...props} className={classes.link} />;
};

export const Form = (props: any) => {
  const classes = useStyles();
  return <form {...props} className={classes.form} />;
};
